<template>
  <div class="index">
    <TheModeA />
    <div class="modelb">
      <TheModeB />
    </div>

    <TheModeC />
    <TheModeD />
  </div>
</template>

<script>
import TheModeA from "@/components/index/TheModeA";
import TheModeB from "@/components/index/TheModeB";
import TheModeC from "@/components/index/TheModeC";
import TheModeD from "@/components/index/TheModeD";
import { menuqueryaddressid } from "@/api/menu";

export default {
  components: {
    TheModeA,
    TheModeB,
    TheModeC,
    TheModeD,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    //获取拼接参数 examp： http://10.200.111.37/checkDto
    if (this.$route.query.service) {
      //通过该地址查询该菜单按钮
      this.MenuQueryAddressId({ routAddress: this.$route.query.service });
    }
  },
  methods: {
    MenuQueryAddressId(MenuQueryDto) {
      menuqueryaddressid(MenuQueryDto).then((res) => {
        if (res.status === 2000) {
          //点击该按钮进入记录的页面
          this.$store.dispatch("UpdateActive", res.data);
        }
      });
    },
  },
};
</script>


<style scoped lang="scss">
.index {
  height: 100%;

  
  .modelb {
    height: 100%;
  }
  // min-width: 1400px;
}
</style>
